export default __webpack_public_path__ + "static/media/four_bg.2bbbbb53.png";